import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router';
import { clearSessionCredentials } from '../../../../../../globalFunctions';
import { LogicManagerModule } from '../../../../../../modules/config/LogicManagerModulesList';
import { Exercise } from '../../../../../../types';

export const saveModuleChanges = async (
    token: string,
    navigate: NavigateFunction,
    module
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/module/${module.id}`,
            module,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao salvar alterações da modal',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
            clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return response;
        }
    }
};

export const saveExerciseChanges = async (
    token: string,
    navigate: NavigateFunction,
    exercise: Exercise
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/exercise/${exercise.id}`,
            exercise,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao salvar alterações dos exercícios',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
           // clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return response;
        }
    }
};
